export const features = {
    COMMANDS_ENABLED: true,
};
